import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SvgIcon from '@mui/material/SvgIcon';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  console.log(user);
  const toggleDrawer = (state: boolean) => () => setOpen(state);

  const menuItems = [
    { label: 'Home', path: '/video-creator' },
    { label: 'Videos', path: '/videos' },
    { label: 'Video Merge', path: '/video-merge' },
    { label: 'AI Videos', path: '/ai-videos' },
    { label: 'Deleted Images', path: '/second-page' },
    { label: 'Third Page', path: '/thirt-page' },
  ];

  const initials = React.useMemo(() => {
    if (!user?.name) return '?';
    const parts = user.name.trim().split(/\s+/);
    const first = parts[0]?.[0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
  }, [user?.name]);

  const handleOpenUserMenu = (e: React.MouseEvent<HTMLButtonElement>) => setMenuAnchor(e.currentTarget);
  const handleCloseUserMenu = () => setMenuAnchor(null);
  const handleProfile = () => {
    handleCloseUserMenu();
    navigate('/profile');
  };
  const handleLogout = () => {
    handleCloseUserMenu();
    logout();
    navigate('/', { replace: true });
  };

  return (
    <>
      <AppBar position="fixed" color="primary">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer(true)}
            sx={{ mr: 2 }}
          >
            <Typography component="span" variant="h6" sx={{ lineHeight: 1 }}>
              ≡
            </Typography>
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="go home"
            onClick={() => navigate('/video-creator')}
            sx={{ mr: 1 }}
          >
            <SvgIcon fontSize="medium" viewBox="0 0 24 24">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </SvgIcon>
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            VideoCreator
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar src={user?.avatarUrl || undefined}>{initials}</Avatar>
            <Button
              color="inherit"
              onClick={handleOpenUserMenu}
              endIcon={<Typography component="span" variant="body2">▾</Typography>}
            >
              {user?.name || 'Guest'}
            </Button>
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleCloseUserMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem onClick={handleProfile}>Profile</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 260 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
          <Box sx={{ p: 2 }}>
            <Typography variant="h6">Menü</Typography>
          </Box>
          <Divider />
          <List>
            {menuItems.map((item) => (
              <ListItem key={item.path} disablePadding>
                <ListItemButton
                  selected={location.pathname === item.path}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
            {user?.role === 'ADMIN' && (
              <ListItem key="/admin" disablePadding>
                <ListItemButton
                  selected={location.pathname === '/admin'}
                  onClick={() => navigate('/admin')}
                >
                  <ListItemText primary="Admin" />
                </ListItemButton>
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
      <Toolbar />
    </>
  );
};

export default Navbar;
